<template>
    <Head title="Meu Perfil" />
    <AuthenticatedLayout>
        <Heading title="Meu Perfil" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28"/>
        <div class="component-background-desktop component-background-mobile pt-10 pb-14 px-4 xl:px-[16vw] min-h-[80vh]">
            <button @click="goBack" :class="stateBack" class="back-sm hover:text-blue-600 hover:underline text-blue-500">Voltar</button>
            <h2 class="text-3xl mt-8 font-semibold text-primary text-left">Alterar Senha</h2>
            <p class="text-primary">Digite sua senha atual para criar uma nova senha:</p>
            <form class="max-w-[435px]">
                <label class="mb-1 mr-5 flex font-bold pt-4 text-primary">Senha</label>
                <Input placeholder="*********" id="password" v-model="form.password" type="password" :state="$page.props.flash.error ? 'error' : ''" required autofocus/>
                <p class="text-red-500 text-xs">{{$page.props.flash.error}}</p>
                <Button class="mt-14" @click.prevent="submit()" :enabled="form.password ? true : false">Avançar</Button>
            </form>
            <!-- <Input placeholder="*********" :state="inputState" id="password" v-model="form.password" type="password" required autofocus/> -->
        </div>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Input from "@/Components/UI/Form/Input.vue";
import { Head } from "@inertiajs/inertia-vue3";
import Heading from '@/Components/UI/Texts/Heading.vue';
import Back from '@/Components/UI/Back.vue'
import Button from '@/Components/Button.vue';



export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Back,
        Input,
        Button
    },
    data() {
        return{
            form: this.$inertia.form({
                password: ''
            })
        }
    },
    methods: {
        submit() {
            if(this.form.password) {
                this.form.post('/my-profile/verify-password');
            }
        },
        goBack(){
            return window.history.go(-1);
        }
    }
};
</script>
